import PrismicPage from 'utils/prismic/PrismicPage';
import React from 'react';

const SiteSupportPage = () => <PrismicPage pageName="support" title="Support" />;

export default SiteSupportPage;
